/* eslint-disable react/jsx-no-duplicate-props */
/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Images
import aboutUsIcon from "assets/images/aboutus.svg";
import aboutUs from "assets/images/aboutus.jpeg";

function AboutUs() {
  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container alignItems="center">
          <Grid item xs={12} md={5} sx={{ ml: "auto" }}>
            <MKBox position="relative">
              <MKBox
                component="img"
                src={aboutUs}
                alt="About Us"
                width="100%"
                objectFit="cover"
                objectPosition="50% 50%"
              />
            </MKBox>
          </Grid>
          <Grid item sx={12} md={6} sx={{ ml: { xs: 0, lg: 3 } }}>
            <MKBox position="relative">
              <MKBox
                mt="20px"
                component="img"
                src={aboutUsIcon}
                alt="About Us"
                width="70px"
                objectFit="cover"
                objectPosition="50% 50%"
              />
            </MKBox>
            <MKTypography variant="h2">ABOUT US</MKTypography>
            <MKTypography variant="body2" color="text">
              Hee Plumbing & Sanitary Specialist Pte Ltd is a second-generation plumbing company in
              Singapore, officially established in 2023. We continue the legacy of Hee Plumbing
              Services, a family-run business since 1999, we specialize in plumbing, sanitary,
              electrical, and general repair works.
              <br />
              We thrive to provide a high standard of service for all our existing and future
              clients with the best up to date tools and experience.
            </MKTypography>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default AboutUs;
